import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const NodeJS = () => {
  return (
    <StartInterviewLayout type="nodejs"/>
  )
}

export default NodeJS;